module.exports = __webpack_public_path__ + "img/clip.0a7cc9aa.svg";